/* istanbul ignore file */
import React, { lazy } from 'react'

import SiteRoute from '../../components/SiteRoute'

const NewLandingPage = lazy(() => import('./pages/NewLandingPage'))

export default [<SiteRoute key="nlihp" exact path="/" component={NewLandingPage} />]
